import React, { ReactNode, useId } from 'react'
import { useIntl } from 'react-intl'
import { IconRegularClose } from '@notino/react-styleguide'
import { Portal } from 'react-portal'

import Modal, { ModalModel } from '../../../atoms/Modal/Modal'
import * as SC from './ReservationBookingDialogStyles'

type Props = {
	isOpen: boolean
	onClose: () => void
	title: ReactNode
	description: ReactNode
	footer: ReactNode
	showHeaderCloseButton?: boolean
	isHeaderCloseButtonDisabled?: boolean
}

const ReservationBookingDialog = (props: Props) => {
	const { isOpen, onClose, title, description, footer, showHeaderCloseButton = false, isHeaderCloseButtonDisabled = false } = props
	const { formatMessage } = useIntl()
	const titleId = useId()
	const descriptionId = useId()

	const handleClose = () => {
		if (!isOpen || isHeaderCloseButtonDisabled) {
			return
		}

		onClose()
	}

	return (
		<Portal>
			<Modal
				show={isOpen}
				layout={'fullScreenOnMobileCustom'}
				hideDefaultCloseButton
				desktopMaxWidth={360}
				onClose={handleClose}
				disableOnBlurClose={isHeaderCloseButtonDisabled}
				disableCloseOnEscape
				size={ModalModel.ModalSizes.default}
				noBorders
				ariaLabelledBy={titleId}
				ariaDescribedBy={descriptionId}
			>
				<SC.ModalContent>
					{showHeaderCloseButton ? (
						<SC.Header>
							<SC.HeaderTitle id={titleId}>{title}</SC.HeaderTitle>
							<SC.CloseButton
								type={'button'}
								disabled={isHeaderCloseButtonDisabled}
								onClick={handleClose}
								aria-label={formatMessage({ id: 'Close modal', defaultMessage: 'Close' })}
							>
								<IconRegularClose color={'icon.primary'} width={'1.5rem'} height={'1.5rem'} aria-hidden />
							</SC.CloseButton>
						</SC.Header>
					) : (
						<SC.SimpleHeaderTitle id={titleId}>{title}</SC.SimpleHeaderTitle>
					)}
					<SC.Description id={descriptionId}>{description}</SC.Description>
					{footer}
				</SC.ModalContent>
			</Modal>
		</Portal>
	)
}

export default ReservationBookingDialog
